var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-section"},[(_vm.$slots.header)?_c('div',{staticClass:"info-section__header"},[_vm._t("header"),_c('hr')],2):_vm._e(),_c('div',{staticClass:"info-section__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }